<script>
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import RegisterUserAccount from '@/components/user/register-user-account.vue'
import LoginForm from '@/components/auth/login-form.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwAmount from '@/components/generic/forms/tw-amount.vue'
import TwWysiwyg from '@/components/generic/forms/tw-wysiwyg.vue'
import TwDate from '@/components/generic/forms/tw-date.vue'
import { useAuthStore } from '@/stores/auth.js'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwUploadField from '@/components/generic/uploads/tw-upload-field.vue'
import TwSelect from '@/components/generic/forms/tw-select.vue'
import TeamEditModal from '@/components/teams/team-edit-modal.vue'
import ImageCropModal from '@/components/images/image-crop-modal.vue'
import UserAvatarEditor from '@/components/user/user-avatar-editor.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'

export default {
  name: 'FundraiserJoinPage',
  components: { TwTransitionContainer, TwLoadingSpinner, UserAvatarEditor, ImageCropModal, TeamEditModal, TwSelect, TwUploadField, TwValidationErrors, TwDate, TwWysiwyg, TwAmount, TwInput, LoginForm, RegisterUserAccount, TwModal, TwContainer, TwButton, TwCard },
  mixins:[fundraiserPublicFetchMixin, loggedInUserMixin],
  props: {
    fundraiserInvite: {
      type: Object,
      default: null
    },
    teamId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      LoadingJoiningCause: false,
      ValidationErrorMessage: null,
      CustomFields: {},
      FundraiserPageData: {
        title: null,
        short_description: null,
        long_description: null,
        goal: null,
        deadline: null
      },
      TeamCreated: null,
      YoutubeVideoUrl: null,
      ShowYoutubeVideoPreview: false,
      PhotoUploaded: null
    }
  },
  computed: {
    youtubeVideoSlug() {
      if(this.YoutubeVideoUrl) {
        return this.YoutubeVideoUrl.split('v=')[1]
      }
      return null
    },
    teamsAvailable() {
      if(this.fundraiser.teams) {
        const teams = this.fundraiser.teams.map(team => ({ id: team.id, name: team.name }))
        if (this.TeamCreated) {
          teams.push({ id: this.TeamCreated.id, name: this.TeamCreated.name })
        }
        return teams
      }
      return null
    },
    canBeCropped() {
      return !!(this.PhotoUploaded && ['jpg','jpeg','png','webp'].indexOf(this.PhotoUploaded.extension) > -1)
    },
    loggedInUser() {
      return useAuthStore().user
    },
    customFieldsRequired() {
      if(this.fundraiser.custom_fields) {
        return this.fundraiser.custom_fields.filter(item => item.require_on_join)
      }
      return []
    }
  },
  async mounted() {
    await this.fetchFundraiser()
    this.FundraiserPageData.title = this.fundraiser.title
    this.FundraiserPageData.short_description = this.fundraiser.short_description
    this.FundraiserPageData.long_description = this.fundraiser.settings.default_long_desc? this.fundraiser.settings.default_long_desc : null
    this.FundraiserPageData.goal = this.fundraiser.settings.default_goal ? this.fundraiser.settings.default_goal: this.fundraiser.goal
    this.FundraiserPageData.deadline = this.fundraiser.settings.default_deadline ? this.fundraiser.settings.default_deadline: this.fundraiser.deadline


    if(this.fundraiserInvite && this.fundraiserInvite.existing_user && this.fundraiserInvite.existing_user.autologin_token) {
      await useAuthStore().loginViaToken(this.fundraiserInvite.existing_user.autologin_token)
    }
    else if(!this.loggedInUser) {
      // await this.openRegisterUserModal()
    }

    if(this.teamId) {
      this.FundraiserPageData.belongs_to_team_id = this.teamId
    }
  },
  methods: {
    async openRegisterUserModal() {
      await this.$refs.userRegisterAccountModal.open()
      if(this.fundraiserInvite && this.$refs.registerUserAccount) {
        this.$refs.registerUserAccount.setEmail(this.fundraiserInvite.email)
      }
    },
    cropped(item){
      this.PhotoUploaded = item
    },
    async userRegistered(user) {
      await this.$refs.userRegisterAccountModal.close()
      await useAuthStore().login(user, true)
      this.FundraiserPageData.title = this.fundraiser.title + ' by ' + user.name
    },
    userLoggedIn() {
      this.$refs.userLoginModal.close()
      this.FundraiserPageData.title = this.fundraiser.title + ' by ' + useAuthStore().user.name
    },
    createdTeam(team) {
      this.TeamCreated = team
      this.FundraiserPageData.belongs_to_team_id = team.id
    },
    async joinCause() {
      try {
        if(confirm('Are you sure you want to join this cause?')) {
          this.ValidationErrorMessage = null
          this.LoadingJoiningCause = true
          const fundraiserPage = await useFundraiserStore().fundraiserJoin(this.fundraiser.id, {
            ...(this.CustomFields && { custom_fields: this.CustomFields }),
            ...(this.fundraiserInvite && { fundraiser_invite_id: this.fundraiserInvite.id }),
            ...this.FundraiserPageData,
            ...(this.PhotoUploaded && { photo_upload_id: this.PhotoUploaded.id }),
            ...(this.YoutubeVideoUrl && { youtube_video_url: this.YoutubeVideoUrl })
          })
          this.LoadingJoiningCause = false
          this.$router.push({ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug } })
          this.$notify('You have successfully joined this cause')
        }
      } catch (e) {
        console.error(e)
        this.LoadingJoiningCause = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        this.$notify('An error occurred while joining this cause', 'error')
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container class="max-w-[960px]">
    <div v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_joining" class="p-10 text-center">
      <h2 class="mt-10 mb-5">
        {{ fundraiser.title }}
      </h2>
      <div>
        You cannot join this campaign at this time.
      </div>
    </div>
    <div v-else>
      <h2 v-if="fundraiserInvite" class="mt-10 mb-5 text-center">
        Hello {{ loggedInUser? loggedInUser.name: fundraiserInvite.email }}
      </h2>
      <h2 v-if="fundraiser" class="mt-10 mb-5 text-center">
        Join this Cause!
      </h2>
      <h4 v-if="fundraiser" class="text-center">
        {{ fundraiserInvite? 'You have been invited to join the fundraiser ':'Create a personal fundraising page for' }} <span class="italic">{{ fundraiser.title }}</span>
      </h4>
      <tw-transition-container>
        <tw-card v-if="!Loading && fundraiser" class="my-6 bg-white" size="lg">
          <tw-card v-if="fundraiserInvite && fundraiserInvite.message" class="bg-yellow-50">
            <div v-html="fundraiserInvite.message" />
          </tw-card>
          <div v-if="fundraiser.settings && fundraiser.settings.signup_instructions">
            <div v-html="fundraiser.settings.signup_instructions" />
          </div>
          <div v-if="loggedInUser">
            <h5 class="text-amber-500 mt-8">
              Welcome, <span class="ml-2 italic"> {{ loggedInUser.name }}</span>
            </h5>
          </div>
          <div v-else class="mt-8">
            <h4 class="text-center">
              {{ fundraiserInvite? 'Quickly create an account to join this fundraiser':'Do you already have an account with us?' }}
            </h4>
            <div class="flex justify-center gap-3 mt-4">
              <tw-button variant="amber" size="lg" @click="openRegisterUserModal">
                Signup
              </tw-button>
              <tw-button v-if="!fundraiserInvite" size="lg" @click="$refs.userLoginModal.open()">
                Login
              </tw-button>
            </div>
          </div>
          <div v-if="loggedInUser" class="mt-8 flex flex-col gap-4">
            <div v-if="fundraiser.settings.lock_title && fundraiser.settings.lock_title === true" class="form-label">
              <strong>Title:</strong> {{ FundraiserPageData.title }}
            </div>
            <tw-input v-else v-model="FundraiserPageData.title" label="Title of your fundraiser" />
            <div v-if="fundraiser.settings.lock_goal" class="form-label">
              Goal: ${{ FundraiserPageData.goal }}
            </div>
            <tw-amount v-else v-model="FundraiserPageData.goal" :disabled="fundraiser.settings && fundraiser.settings.lock_goal" prepend="$" label="Goal amount" />
            <div v-if="fundraiser.settings.lock_deadline === true" class="form-label">
              Deadline: {{ $filters.formatDateOnly(FundraiserPageData.deadline) }}
            </div>
            <tw-date v-else v-model="FundraiserPageData.deadline" :disabled="fundraiser.settings && fundraiser.settings.lock_deadline" label="Fundraising Deadline" />
            <tw-wysiwyg v-model="FundraiserPageData.long_description" :disabled="fundraiser.settings && fundraiser.settings.lock_long_desc" class="mb-8 mt-2" />
          </div>
          <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
          <div v-if="loggedInUser && fundraiser.settings.enable_teams" class="form-spacing">
            <div class="form-label">
              Join a team <span v-if="fundraiser.settings.enable_create_teams" />
            </div>
            <div class="flex flex-row gap-2">
              <tw-select v-if="teamsAvailable && teamsAvailable.length > 0" v-model="FundraiserPageData.belongs_to_team_id" :options="teamsAvailable" value-key="id" label-key="name" />
              <div v-if="fundraiser.settings.enable_create_teams" class="mt-2 font-semibold">
                or
              </div>
              <tw-button v-if="fundraiser.settings.enable_create_teams" size="sm" @click="$refs.createTeamModal.open()">
                Create a New Team
              </tw-button>
            </div>
            <team-edit-modal ref="createTeamModal" :fundraiser="fundraiser" @created="createdTeam" />
          </div>

          <div v-if="loggedInUser" class="form-spacing">
            <div>
              <user-avatar-editor v-if="loggedInUser" />
            </div>
            <div class="">
              <div>
                <div class="form-label mb-3">
                  Upload an Image
                </div>
                <tw-upload-field v-model="PhotoUploaded" images-only />
              </div>
              <div v-if="PhotoUploaded">
                <div class="mt-4 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                  <div class="overflow-hidden rounded-lg bg-white shadow">
                    <div :class="['p-3 flex justify-center', {'h-40': !readonly}]">
                      <a :href="PhotoUploaded.url" target="_blank" class="text-blue-500 underline">
                        <img :src="PhotoUploaded.url" class="object-cover object-center max-h-full">
                      </a>
                    </div>
                    <div class="px-3 pb-3 flex gap-2">
                      <tw-button v-if="canBeCropped" variant="light" size="sm" class="grow" block @click="$refs.imageCropModal.open()">
                        <icon icon="scissors" class="h-3" /> Crop
                      </tw-button>
                      <tw-button variant="light" size="sm" icon="trash" @click="PhotoUploaded = null" />
                    </div>
                  </div>
                </div>
                <image-crop-modal v-if="canBeCropped" ref="imageCropModal" :upload="PhotoUploaded" @cropped="cropped" />
              </div>
            </div>
            <div v-if="customFieldsRequired && customFieldsRequired.length > 0">
              <div class="form-label">
                Custom fields:
              </div>
              <tw-input v-for="(customField, index) in customFieldsRequired" :key="'custom-field-key-' + index" v-model="CustomFields[customField.name]" :label="customField.name" />
            </div>

            <div>
              <tw-input v-model="YoutubeVideoUrl" label="Video from Youtube (optional)" placeholder="Youtube URL" @blur="ShowYoutubeVideoPreview = true" />
              <div v-if="ShowYoutubeVideoPreview && youtubeVideoSlug" class="mt-4">
                <iframe class="embed-responsive-item w-full h-80" :src="`https://www.youtube.com/embed/${youtubeVideoSlug}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
              </div>
            </div>
          </div>
          <div v-if="loggedInUser" class="flex justify-center mt-10">
            <tw-button size="lg" :loading="LoadingJoiningCause" variant="amber" @click="joinCause">
              Create Fundraising Page
            </tw-button>
          </div>
          <tw-modal ref="userRegisterAccountModal" no-footer>
            <register-user-account ref="registerUserAccount" no-redirect user-role="supporter" @cancel-registration="$refs.userRegisterAccountModal.close()" @user-registered="userRegistered" />
          </tw-modal>
          <tw-modal ref="userLoginModal" no-footer>
            <login-form no-redirect @user-logged-in="userLoggedIn" />
          </tw-modal>
        </tw-card>
        <tw-loading-spinner v-else />
      </tw-transition-container>
    </div>
  </tw-container>
</template>

<style scoped>

</style>
